module.exports = __webpack_public_path__ + "static/img/img20.646ba97.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img20.png
// module id = r/Qe
// module chunks = 1